import React from 'react';
import { render } from '@testing-library/react';
import { Announcement } from './Announcement';

describe('Announcement', () => {
	beforeEach(() => jest.spyOn(console, 'error'));

	it('should pass through data automation attributes', () => {
		const { container } = render(
			<Announcement
				status="info"
				title="This is a sandbox environment, not your live account"
				actionName="Learn More"
				data-auto-sel="automation-selector"
			/>
		);

		const element = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(element).not.toBeNull();
	});
});
